














import { Vue, Component } from 'vue-property-decorator';
import UIModule from '@/store/modules/ui';

@Component({
  components: {},
})
export default class AppBar extends Vue {
  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.width < 800;
  }

  private openDrawer() {
    UIModule.SET_DRAWER(true);
  }
}

